import * as React from "react";
const SvgDots = props => <svg xmlns="http://www.w3.org/2000/svg" width={12} height={2} fill="none" viewBox="0 0 12 2" {...props}><path fill="currentColor" d="M0 0h2v2H0zM10 0h2v2h-2zM5 0h2v2H5z" /></svg>;
export default SvgDots;